/**
 * Get client name from domain
 */
export function getClientFromDomain() {
    const domain = window.location.hostname;
    if (domain.includes("verify")) return "verify";
    if (domain.includes("mobiafrica")) return "mobiafrica";
    if (domain.includes("suzuki")) return "suzuki";
    if (domain.includes("autocity")) return "autocity";
    if (domain.includes("yumbi")) return "yumbi";
    if (domain.includes("santam")) return "santam";
    if (domain.includes("altron")) return "altron";
    if (domain.includes("swift")) return "swift";
    if (domain.includes("webuycars")) return "webuycars";
    if (domain.includes("getsavvi")) return "getsavvi";
    return null;
}

/**
 * Get default landing page for client based on domain
 */
export function getClientDefaultRoute(role = null) {
    const client = getClientFromDomain();
    const normalizedRole = role ? role.toUpperCase() : '';

    const workbenchClients = ['verify', 'swift', 'suzuki', 'mobiafrica'];

    if (workbenchClients.includes(client) && normalizedRole === 'CLIENT') {
        return { name: 'workbench' };
    }

    return { name: 'project_table' };
}

/**
 * Get client-specific back button label
 */
export function getBackButtonLabel(role = null) {
    const client = getClientFromDomain();
    const normalizedRole = role ? role.toUpperCase() : '';
    const workbenchClients = ['verify', 'swift', 'suzuki', 'mobiafrica'];

    if (workbenchClients.includes(client) && normalizedRole === 'CLIENT') {
        return 'Back to Workbench';
    }
    return 'Back to Projects';
}

export function handle_registration_redirect(response, router, store, fetch_current_service,GET_CLIENT_ID) {
    const role = response.role.toUpperCase();
    const status = response.status;

    switch (role) {
        case 'CUSTOMER': {

            if (GET_CLIENT_ID == null){
                sessionStorage.clear(); 
                localStorage.clear(); 
                router.push('/');
            } else {
            const workflow_id = response.workflow_id;
            
            if (workflow_id !== null) {
                store.dispatch('update_workflow_id', workflow_id);
                if (fetch_current_service) {
                    fetch_current_service();
                }
            } else {
                router.push({ name: 'assigned_workflows' });
            }
        }
            break;
        }
        case 'CLIENTADMIN':
            handle_client_redirect(status, router, role);
            break;
        case 'SYSTEMADMIN':
            router.push('system_admin/admin_dashboard');
            break;
        case 'DIRECTOR': {
            switch (status) {
                case 'no_consent':
                    router.push('/director_consent');
                    break;
                case 'not_verified':
                    router.push('/facial_biometrics_verification');
                    break;
                case 'no_proof_of_address':
                    router.push('/upload_proof_of_address');
                    break;
                default:
                    router.push('/thank_you_page');
            }
            break;
        }
        case 'CLIENT': {
            router.push(getClientDefaultRoute(role));
            break;
        }
        default:
            router.push('/company_pending');
    }
}

function handle_client_redirect(status, router, role) {
    const defaultRoute = getClientDefaultRoute(role);

    switch (status) {
        case 'no_profile_info':
            router.push('/facial_biometrics');
            break;
        case 'not_verified':
            router.push('/facial_biometrics');
            break;
        case 'no_company_profile':
            router.push('/company_verification');
            break;
        case 'failed_verification':
        case 'pending':
        case 'declined':
            router.push('/company_pending');
            break;
        case 'approved':
            router.push(defaultRoute);
            break;
        default:
            router.push(defaultRoute);
    }
}
